import React, { useEffect, useRef, useState, useCallback } from "react";
import Axios from "axios";
import { connect } from "react-redux";
// import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../../store/actions/index";
import classes from "./HorizontalScroll.module.css";

const HorizontalScroll = (props) => {
  const menu_wrapper = useRef(null);
  const itemList = useRef(null);
  const item = useRef(null);
  const leftPaddle = useRef(null);
  const rightPaddle = useRef(null);

  var workouts = props.plan.workouts?props.plan.workouts:[];



  // console.log(workouts)
  useEffect(() => {

    try{
       
       // get items dimensions
        // window.itemsLength = workouts.length;
        window.itemsLength = 200000;
        window.itemSize = item.current.offsetWidth;
      
        window.menuWrapperSize = getMenuWrapperSize();
        // the wrapper is responsive
        window.addEventListener("resize", function (event) {
          // do stuff here
          try {
            window.menuWrapperSize = getMenuWrapperSize();
          } catch (error) {}
        });
        // size of the visible part of the menu is equal as the wrapper size
        window.menuVisibleSize = window.menuWrapperSize;
        window.menuSize = getMenuSize();
        //  console.log(window.menuWrapperSize,window.menuSize)
        // get how much of menu is invisible
        window.menuInvisibleSize = window.menuSize - window.menuWrapperSize;

        document
          .getElementById("itemList" + props.index)
          .addEventListener("scroll", () => {
            onListScroll();
          });
        leftPaddle.current.style.display = "none";

    }catch(error){
        return null
    }
   



  }, []);

  

  //duration of scroll animation
  var scrollDuration = 300;

  // get some relevant size for the paddle triggering point
  var paddleMargin = 20;

  // get wrapper width
  var getMenuWrapperSize = function () {
    return menu_wrapper.current.offsetWidth;
  };

  // get total width of all menu items
  var getMenuSize = function () {
    return window.itemsLength * window.itemSize;
  };

  // get how much have we scrolled to the left
  var getMenuPosition = function () {
    return itemList.current.scrollLeft;
  };

  // finally, what happens when we are actually scrolling the menu

  const onListScroll = () => {
    // get how much of menu is invisible
    let menuInvisibleSize = window.menuSize - window.menuWrapperSize;
    // get how much have we scrolled so far
    var menuPosition = getMenuPosition();

    var menuEndOffset = menuInvisibleSize - paddleMargin;
    // console.log(menuPosition,menuEndOffset)
    // show & hide the paddles
    // depending on scroll position
    if (menuPosition <= paddleMargin) {
      // alert("1")
      leftPaddle.current.style.display = "none";
      rightPaddle.current.style.display = "block";
    } else if (menuPosition >= menuEndOffset) {
      // alert("3")
      leftPaddle.current.style.display = "block";
      rightPaddle.current.style.display = "none";
    } else if (menuPosition < menuEndOffset) {
      // alert("2")
      // show both paddles in the middle
      leftPaddle.current.style.display = "block";
      rightPaddle.current.style.display = "block";
    }
  };

  const onRightPaddleClick = (id) => {
    document
      .getElementById("itemList" + props.index)
      .scrollBy({ left: window.menuInvisibleSize, top: 0, behavior: "smooth" });
    //    console.log(item)
  };

  const onLeftPaddleClick = (id) => {
    document.getElementById("itemList" + props.index).scrollBy({
      left: -window.menuInvisibleSize,
      top: 0,
      behavior: "smooth",
    });
  };

  let [inputWorkout, setWorkout] = useState({
    // id: props.plan.workouts.id,
    // title: props.plan.workouts.title,
    // url: props.plan.workouts.url,
  });

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setWorkout({ ...inputWorkout, [name]: value });
  });

  const handleEditWorkout = (e) => {
    e.preventDefault();
    let editedWorkout = {
      id: inputWorkout.id,
      title: inputWorkout.title,
      url: inputWorkout.url,
    };
    // console.log(editedWorkout, props.plan);
    props.onEditWorkout(editedWorkout, props.plan);
  };

  const handleDeleteWorkout = (e, id) => {
    e.preventDefault();
    // console.log(id, props.plan.id);
    props.onDeleteWorkout(id, props.plan.id);
  };

  //   console.clear();
 
  return ( 
    <>
      <div className={classes.MENUWRAPPER} ref={menu_wrapper}>
        <ul
          className={classes.MENU}
          ref={itemList}
          id={"itemList" + props.index}
        >
          {workouts.map((workout) => (
            <li className={classes.ITEM} key={workout.id} ref={item}>
              <div>
                <iframe
                  height="80%"
                  width="100%"
                  src={workout.url}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen="allowfullscreen"
                  mozallowfullscreen="mozallowfullscreen"
                  msallowfullscreen="msallowfullscreen"
                  oallowfullscreen="oallowfullscreen"
                  webkitallowfullscreen="webkitallowfullscreen"
                ></iframe>
                <div style={{ height: "100px", overflow: "clip" }}>
                  <p>
                    <h6>{workout.title} </h6>
                    <button
                      className="btn btn-primary btn-sm m-2"
                      data-toggle="modal"
                      data-target={`#edit${workout.id}${props.plan.id}`}
                      onClick={() => {
                        setWorkout((inputWorkout = workout));
                      }}
                    >
                      Edit
                    </button>
                    {/* ------------------------------------ Edit Workout Modal starts ------------------------------------*/}
                    <div
                      className="modal fade"
                      id={`edit${workout.id}${props.plan.id}`}
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Editing: <b>{workout.title}</b>
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="form-group">
                              <label htmlFor="title" className="col-form-label">
                                Title:
                              </label>
                              <input
                                name="title"
                                type="text"
                                className="form-control"
                                id="title"
                                value={inputWorkout.title}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="title" className="col-form-label">
                                Youtube URL:
                              </label>
                              <textarea
                                name="url"
                                type="text"
                                className="form-control"
                                id="url"
                                value={inputWorkout.url}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={handleEditWorkout}
                              disabled={props.editBtnLoading}
                            >
                              {props.editBtnLoading ? "Saving" : "Save"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ------------------------------------ Edit Workout Modal ends ------------------------------------*/}
                    <button
                      className="btn btn-primary btn-sm m-2"
                      data-toggle="modal"
                      data-target={`#delete${workout.id}${props.plan.id}`}
                      // onClick={() => {setWorkout(id: )}}
                    >
                      Delete
                    </button>
                    {/* ------------------------------------ Delete Workout Modal starts ------------------------------------*/}
                    <div
                      className="modal fade"
                      id={`delete${workout.id}${props.plan.id}`}
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Irreversible Operation
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <p>
                              Are you sure you want to delete{" "}
                              <b>{workout.title}</b>
                            </p>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={(e) =>
                                handleDeleteWorkout(e, workout.id)
                              }
                              disabled={props.deleteBtnLoading}
                            >
                              {props.deleteBtnLoading ? "Deleting" : "Delete"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div> 
                    {/* ------------------------------------ Delete Workout Modal ends ------------------------------------*/}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>

        <div className={classes.PADDLES}>
          <button
            className={`${classes.LEFTPADDLE} ${classes.PADDLE}`}
            ref={leftPaddle}
            onClick={() => onLeftPaddleClick("itemList" + props.index)}
          >
            <i className="fa fa-chevron-circle-left" aria-hidden="true"></i>
          </button>
          <button
            className={`${classes.RIGHTPADDLE} ${classes.PADDLE}`}
            onClick={() => onRightPaddleClick("itemList" + props.index)}
            ref={rightPaddle}
          >
            <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    // categories: state.category.categories,
    // workouts: state.workouts.workouts,
    editBtnLoading: state.workouts.editWorkoutLoading,
    deleteBtnLoading: state.workouts.deleteWorkoutLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onEditWorkout: (editedWorkout, actualWorkout) =>
      dispatch(actions.onEditWorkout(editedWorkout, actualWorkout)),
    onDeleteWorkout: (planId, workoutId) =>
      dispatch(actions.onDeleteWorkout(planId, workoutId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(HorizontalScroll, Axios));
